import { combineValidators, isOneOf } from 'revalidate';
import { walletAddressValidator } from 'Components/shared/formElements/validators';
import i18nextTranslate from 'Lang/i18nextTranslate';
import { i18nextKeys } from 'Lang/i18nextKeys';
import { isRequiredWithMessage } from 'Utils/validators';
import { WALLET_TYPE } from 'Enums';

const walletValidator = (values) => {
  return combineValidators({
    Address: walletAddressValidator(values.Type),
    Type: isOneOf(Object.values(WALLET_TYPE))('Crypto'),
    Name: isRequiredWithMessage(i18nextTranslate(i18nextKeys.commonWalletName)),
  })(values);
};

export default walletValidator;
